export const BANNED_CODE = 'ACCOUNT_BANNED';
export const BANNED_MESSAGE = 'Your account has been suspended. Contact support@celpipmax.com if you think this is a mistake.';

export const isBannedError = (err) => err?.response?.status === 403 && err?.response?.data?.detail === BANNED_CODE;
